import useIsMobile from "../hooks/useIsMobile";
import NavBar from "./NavBar";

export default function ContractLayout({ title, subtitle, children }) {
  const isMobile = useIsMobile();
  return (
    <div
      style={{
        minHeight: "100vh",
        background: "linear-gradient(165deg, #f5f0e8 0%, #ede6da 30%, #f0e8d8 100%)",
        fontFamily: "'DM Sans', sans-serif",
      }}
    >
      <link
        href="https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;600;700&family=Playfair+Display:wght@700;800&display=swap"
        rel="stylesheet"
      />

      <NavBar />

      {/* Header */}
      <div
        style={{
          background: "linear-gradient(135deg, #2d2418 0%, #4a3520 50%, #3d2a18 100%)",
          padding: isMobile ? "28px 16px" : "40px 24px",
          textAlign: "center",
          position: "relative",
          overflow: "hidden",
        }}
      >
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background:
              "radial-gradient(circle at 20% 50%, rgba(196, 93, 62, 0.15) 0%, transparent 50%), radial-gradient(circle at 80% 30%, rgba(196, 93, 62, 0.1) 0%, transparent 40%)",
          }}
        />
        <div style={{ position: "relative", zIndex: 1 }}>
          <div
            style={{
              display: "inline-block",
              padding: "6px 16px",
              backgroundColor: "rgba(196, 93, 62, 0.2)",
              borderRadius: "20px",
              fontSize: "12px",
              fontWeight: 600,
              color: "#e8a88a",
              letterSpacing: "0.1em",
              textTransform: "uppercase",
              marginBottom: "16px",
            }}
          >
            Generator gratuit
          </div>
          <h1
            style={{
              fontFamily: "'Playfair Display', serif",
              fontSize: "clamp(28px, 5vw, 44px)",
              fontWeight: 800,
              color: "#fdfbf7",
              margin: "0 0 12px 0",
              letterSpacing: "-0.02em",
            }}
          >
            {title}
          </h1>
          <p style={{ fontSize: isMobile ? "14px" : "16px", color: "#b8a890", maxWidth: "500px", margin: "0 auto", lineHeight: 1.5 }}>
            {subtitle}
          </p>
        </div>
      </div>

      {children}
    </div>
  );
}
